import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { throttle } from '../../helpers/'
import style from './index.scss'

const BAR_WIDTH = 24
const RESIZE_LIMIT = 50
export const isPositionValid = position => {
  const pos = parseInt(position, 10)
  if (pos >= 0 && pos <= 100) {
    return true
  }
  return false
}

export default class CosmeticScrollbar extends React.Component {
  constructor(props) {
    super(props)
    this.scrollbar = React.createRef()
    this.barWidth = BAR_WIDTH
  }

  componentDidMount() {
    window.addEventListener('resize', this.update)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.update)
  }

  update = throttle(() => {
    this.forceUpdate()
  }, RESIZE_LIMIT)

  calculateBarPosition(percent) {
    const percen = parseInt(percent, 10)
    const scrollAreaWidth = this.scrollbar.current
      ? this.scrollbar.current.offsetWidth
      : 0
    const barsThatFitIntoScrollArea = scrollAreaWidth / this.barWidth
    const position = barsThatFitIntoScrollArea * percen
    // bar starts inside of the scroll area
    return position - percen
  }

  render() {
    const { lightTheme, position } = this.props
    return (
      <div
        aria-hidden="true"
        ref={this.scrollbar}
        className={classNames(style.CosmeticScrollbar, {
          [style.lightTheme]: lightTheme,
        })}
      >
        <div
          className={classNames(style.bar, {
            [style.lightThemeBar]: lightTheme,
          })}
          style={{
            width: `${this.barWidth}px`,
            transform: `translateX(${this.calculateBarPosition(position)}%)`,
          }}
        />
      </div>
    )
  }
}

CosmeticScrollbar.defaultProps = {
  position: 0,
}

CosmeticScrollbar.propTypes = {
  lightTheme: PropTypes.bool,
  // eslint-disable-next-line consistent-return
  position: (props, propName, componentName) => {
    if (!isPositionValid(props[propName])) {
      return new Error(
        `Invalid prop ${propName} supplied to ${componentName}: ${props[propName]}. Value should be a Number between 0 and 100`
      )
    }
  },
}
